import SharedLeads from "./SharedLeads";

export default SharedLeads;
export { SharedLeads };
